<section class="flex flex-col items-start gap-2">
  @for (seat of seats(); track $index) {
    <div class="flex justify-between items-center gap-2 w-full">
      <div class="flex items-center gap-2">
        <div class="flex items-center gap-1">
          <img [src]="images.vehicles.prmSeat" alt="prmSeat" class="h-5 w-5 filter-primary-purple-light" />
          <span>1</span>
        </div>
        <span class="font-bold">=</span>
        <div class="flex items-center gap-1">
          <img [src]="images.vehicles.standardSeat" alt="standardSeat" class="h-5 w-5 filter-primary-purple-light" />
          @if (editable()) {
            <input type="text" inputmode="numeric" [disabled]="disabled()" [value]="seat.numberOfRegularSeats" class="block w-8 h-8 text-center bg-white border rounded-s rounded-e text-base font-normal placeholder-slate-400 focus:outline-none" (change)="change($index, $any($event.target))" />
          } 
          @else {
            <span>{{ seat.numberOfRegularSeats }}</span>
          }
        </div>
        <img [src]="images.info" alt="convertibleSeatInfo" class="w-4 h-4 cursor-pointer" [tooltip]="literalService.get('vehicles.tooltips.convertibleSeats', true)" [position]="TooltipPosition.BELOW" />
      </div>
      @if (editable()) {
        <img [src]="images.trash" alt="removeConvertibleSeat" class="w-4 h-4 cursor-pointer" (click)="removeConvertibleSeat($index)" />
      }
    </div>
  }
  @if (editable()) {
    <input type="button" class="secondary gap-4 border-2 font-semibold h-8 w-full uppercase cursor-pointer" [value]="literalService.get('add', true)" (click)="addConvertibleSeat()" />
  }
</section>
